import React, { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ButtonBase
} from "@mui/material";
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { getDeviceImageUri } from "../helpers/untils";
import TripDailyTimelineModal from "./TripDailyTimelineModal";
import TimeTuroTripListContent from "./TimeTuroTripListContent";
import TripTimelineSpeedBox from "./TripTimelineSpeedBox";
import { Grid } from "@material-ui/core";
import TripInProgressContent from "./TripInProgressContent";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: '25px',
    height: '25px',
    filter: 'brightness(0) invert(1)',
  },
  avatar: {
    width: '25px',
    height: '25px',
    transform: 'scale(2)'
  }
}));

const TripTimelineContent = (props) => {
  const { pageData = {}, apiLoading } = props;
  const { device, timelineList = [] } = pageData;
  const classes = useStyles();

  const [currentItem, setCurrentItem] = useState({});
  const [tripDailyTimelineModalOpen, setTripDailyTimelineModalOpen] = useState(false);
  const onClickTimelineItem = (item) => {
    // console.log("onClickTimelineItem::::", item);
    setCurrentItem(item);
    setTripDailyTimelineModalOpen(true);
  }

  return (
    <Box p={2}>
      <Box>
        {
          (apiLoading) ? (
            <Typography variant="body1" align="center">
              Loading...
            </Typography>
          ) : (
            <>
              {/* Header */}
              <Box sx={{ width: '100%', borderBottom: '1px solid #dddddd', pb: 2, mb: 2 }}>
                <Grid container spacing={1} justifyContent="space-between">
                  <Grid item>
                    <Stack direction="row" alignItems="center" spacing={2} mb={2}>
                      <Avatar>
                        <img className={device.image ? classes.avatar : classes.icon} src={getDeviceImageUri(device, true)} alt="" />
                      </Avatar>
                      <Stack direction="column" alignItems="flex-start" spacing={0}>
                        <Typography variant="h6" fontWeight={600}>
                          {device.name}
                        </Typography>
                        <Typography>
                          {device.vin}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <TripInProgressContent
                      pageData={pageData}
                    />
                  </Grid>
                </Grid>
              </Box>

              <TableContainer
                component={Paper}
                elevation={0}     // remove shadow
                sx={{ background: "transparent" }}
              >
                <Table
                  sx={{
                    "& td, & th": { border: 0, padding: '8px 16px' },   // remove ALL borders
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ paddingTop: '0px', paddingBottom: '0px' }}></TableCell>
                      <TableCell style={{ paddingTop: '0px', paddingBottom: '0px' }} align="center"></TableCell>
                      <TableCell style={{ paddingTop: '0px', paddingBottom: '0px' }}></TableCell>
                      <TableCell style={{ paddingTop: '0px', paddingBottom: '0px' }}>Minutes</TableCell>
                      <TableCell style={{ paddingTop: '0px', paddingBottom: '0px' }}>Max Speed</TableCell>
                      <TableCell style={{ paddingTop: '0px', paddingBottom: '0px' }}>Turo Trip</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Timeline */}
                    {timelineList.map((item, index) => (
                      <TableRow key={index}>
                        {/* Date */}
                        <TableCell>
                          <ButtonBase onClick={() => onClickTimelineItem(item)} disableRipple={true}>
                            <Stack direction={`column`} justifyContent={`center`} alignItems={`center`}>
                              <b>{item.month}</b>
                              <Typography variant="h5" fontWeight={600}>
                                {item.day}
                              </Typography>
                            </Stack>
                          </ButtonBase>
                        </TableCell>

                        <TableCell align="center" style={{ padding: '0px', overflow: 'hidden' }}>
                          <ButtonBase onClick={() => onClickTimelineItem(item)} disableRipple={true}>
                            <div className="circle-count-container">
                              <Box
                                border="2px solid #ddd"
                                borderRadius="50%"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                                fontWeight={600}
                                className="circle-count-body"
                              >
                                <span>{item.dailyAccCount}</span>
                              </Box>
                            </div>
                          </ButtonBase>
                        </TableCell>

                        <TableCell>
                          {/* Miles */}
                          <Typography width={100} fontWeight={600}>
                            {`${item.dailyOdometer} ${item.distanceUnitStr}`}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {/* Minutes */}
                          <Typography width={60}>
                            {item.dailyMinutes ?? "-"}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          {/* max speed */}
                          <TripTimelineSpeedBox
                            device={device}
                            item={item}
                          />
                        </TableCell>

                        <TableCell align="center">
                          {/* Trip */}
                          <>
                            <TimeTuroTripListContent
                              timeTuroTripList={item.timeTuroTripList}
                            />
                          </>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )
        }
      </Box>

      <TripDailyTimelineModal
        open={tripDailyTimelineModalOpen}
        setOpen={setTripDailyTimelineModalOpen}
        item={currentItem}
        device={device}
      />
    </Box>
  )
}

export default TripTimelineContent;
